module.exports = __webpack_public_path__ + "media/images/home/focus_logo-86142025602876f42594373098d18b15.png";